import { repository, baseURL } from "@/api/base"

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/message/findAll')
    return data
  },

  async get(id) {
    const { data } = await repository.get(baseURL + '/message/' + id)
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/message', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/message', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/message/' + id)
  },

  async findAllByFilter(page, body) {
    const { data } = await repository.post(baseURL + `/message/findAllByFilter/${page}`, body)
    return data
  },

  async sendNotification(id) {
    const { data } = await repository.post(baseURL + `/message/sendNotification?messageId=${id}`)
    return data
  },

  async createMassNotification(text, theme, body) {
    const url = new URL('https:/' + baseURL + '/message/createMassNotification')
    url.searchParams.append("text", text)
    url.searchParams.append("theme", theme)
    const { data } = await repository.post(url.href.slice('https:/'.length), body)
    return data
  },

  async createIndividualNotification(text, theme, id) {
    const url = new URL('https:/' + baseURL + '/message/createIndividualNotification')
    url.searchParams.append("applicationId", id)
    url.searchParams.append("text", text)
    url.searchParams.append("theme", theme)
    const { data } = await repository.post(url.href.slice('https:/'.length))
    return data
  },

  async helpMessage(body, file = null) {
    const formData = new FormData()
    formData.append('message ', new Blob([JSON.stringify(body)], {type : 'application/json'}) )
    if (file) formData.append('files', file)

    const { data } = await repository.post(baseURL + '/message/sendHelpMessage', formData)
    return data
  },

  async createCopyMessageForEdit(messageId) {
    const { data } = await repository.post(baseURL + `/message/edit?messageId=${messageId}`)
    return data
  },
}
